import { useMatches } from '@remix-run/react';
import { atom, useAtom, useStore } from 'jotai';
import { useCallback, useId, useRef } from 'react';
import { safeAtomFamily } from './safe-atom-family';
const getAtom = (atom, key) => {
    let res;
    if (key.includes('+')) {
        // for atom family
        const [atomKey, ...args] = key.split('+');
        const decodeArgs = args.map((a) => decodeURIComponent(a));
        const atomFamily = (atom.atomFamilies || {})[atomKey];
        if (!atomFamily) {
            console.error('atomFamily not found for key: %s', key);
        }
        res = atomFamily(...decodeArgs);
    }
    else {
        // for plain atom
        res = (atom.atoms || {})[key];
    }
    if (process.env.NODE_ENV === 'development' && !res) {
        throw new Error(`no such atom for key: ${key}`);
    }
    return res;
};
const $LoaderState = safeAtomFamily((uniqueId) => {
    const a = atom('idle');
    a.debugLabel = `$LoaderState+${uniqueId}`;
    return a;
});
export const useRouteLoader = (method, params, atom, root = false) => {
    const loaderId = useId();
    const $CurrentLoaderState = $LoaderState(loaderId);
    const [state, setState] = useAtom($CurrentLoaderState);
    const store = useStore();
    const matches = useMatches();
    const stateRef = useRef('idle');
    const load = useCallback(() => {
        if (stateRef.current === 'loading') {
            return;
        }
        stateRef.current = 'loading';
        setState('loading');
        const url = new URL('', location.href);
        url.searchParams.set('method', method);
        if (root) {
            url.searchParams.set('_data', matches[0]?.id || '');
        }
        else {
            url.searchParams.set('_data', matches.at(-1)?.id || '');
        }
        Object.entries(params).forEach(([key, value]) => {
            const str = String(value);
            if (str) {
                url.searchParams.set(key, str);
            }
        });
        window
            .fetch(url)
            .then((rsp) => rsp.json())
            .then((data) => {
            if (!data) {
                return;
            }
            try {
                Object.entries(data).forEach(([key, value]) => {
                    if (!key.startsWith('$')) {
                        return;
                    }
                    const atomToSet = getAtom(atom, key);
                    store.set(atomToSet, value);
                });
            }
            catch (e) {
                console.error(e);
            }
        })
            .catch(console.log)
            .finally(() => {
            stateRef.current = 'idle';
            setState('idle');
        });
    }, [method, params]);
    return {
        state,
        load,
    };
};
export const callRouteLoader = async (routeId, method, params, atom) => {
    const url = new URL('', location.href);
    url.searchParams.set('_data', routeId);
    url.searchParams.set('method', method);
    Object.entries(params).forEach(([key, value]) => {
        const str = String(value);
        if (str) {
            url.searchParams.set(key, str);
        }
    });
    await window
        .fetch(url)
        .then((rsp) => rsp.json())
        .then((data) => {
        if (!data) {
            return;
        }
        try {
            Object.entries(data).forEach(([key, value]) => {
                if (!key.startsWith('$')) {
                    return;
                }
                const atomToSet = getAtom(atom, key);
                window.store.set(atomToSet, value);
            });
        }
        catch (e) {
            console.error(e);
        }
    })
        .catch(console.log);
};
